import { BlockActionType as DbBlockActionType } from "@prisma/client";
import { BlockActionType } from "blocks/types/actions";

export const BLOCK_ACTION_TYPES: Record<DbBlockActionType, BlockActionType> = {
  Navigate: "navigate",
  Notify: "notification",
  OpenExternalUrl: "openExternalUrl",
  ChatbotButton: "chatbot-button",
};
